import { render, staticRenderFns } from "./UnitGeoReturnMovements.vue?vue&type=template&id=5d563325&scoped=true&"
import script from "./UnitGeoReturnMovements.vue?vue&type=script&lang=js&"
export * from "./UnitGeoReturnMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d563325",
  null
  
)

export default component.exports